export default __webpack_public_path__ + "static/media/cash_icon_green.205b07c3.svg";